import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Experiment to control enabling Brand Hover Card on composable product tiles.
 * Shows brand information with product images on hover over brand name.
 */
export const FE_ENABLE_BRAND_HOVER_CARD_250121 = experiment({
  name: "FE_ENABLE_BRAND_HOVER_CARD_250121",
  defaultValue: false,
  identifier: "RetailerToken",
  client: ["RETAILER", "VISITOR_WEB"],
  productArea: "BRAND_CATALOG_COMPLETENESS",
  notifyAfter: "2025-09-25",
});
